import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import ReactGA from "react-ga4";
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer, toast } from "react-toastify";
import { onMessageListener, requestPermission } from "./firebase.js";
import './App.css';
import Metrix from "./metrix.js";

import Login from "./Components/Login/Login";
import Register from "./Components/Register/Register";
import GetCode from "./Components/Login/GetCode";
import Home from "./Components/Home/Home";
import Job from "./Components/Home/Job/Job";
import JobList from "./Components/Home/Job/JobList";
import MakeResume from "./Components/Home/Resume/MakeResume";
import Consulting from "./Components/Home/Consulting/Consulting";
import SingleJob from "./Components/Home/SingleJob/SingleJob";
import Profile from "./Components/Home/Profile/Profile";
import Continents from "./Components/Home/Encyclopedia/Continents";
import Countries from "./Components/Home/Encyclopedia/Countries";
import CountrySingle from "./Components/Home/Encyclopedia/CountrySingle";
import Details from "./Components/Home/Encyclopedia/Details";
import Intro from "./Components/Hoc/Intro";
import Education from "./Components/Home/Education/Education";
import Articles from "./Components/Home/Articles/Articles";
import ArticleSingle from "./Components/Home/Articles/ArticleSingle";
import EducationSingle from "./Components/Home/Education/EducationSingle";
import SendResumeJob from "./Components/Home/Profile/SendResumeJob";
import AboutUs from "./Components/Home/Profile/AboutUs";
import ContactUs from "./Components/Home/Profile/ContactUs";
import Resume from "./Components/Home/Profile/Resume";
import SingleResume from "./Components/Home/Profile/SingleResume";
import PayResume from "./Components/Home/Resume/PayResume";
import PayJob from "./Components/Home/SingleJob/PayJob";
import EducationPaySuccess from "./Components/Home/Education/EducationPaySuccess";
import JobPaySuccess from "./Components/Home/Job/JobPaySuccess";
import PayEducation from "./Components/Home/Education/PayEducation";
import SendResumeEducation from "./Components/Home/Profile/SendResumeEducation";
import ConsTypeSelect from "./Components/Home/Consulting/ConsTypeSelect";
import ConsPayment from "./Components/Home/Consulting/ConsPayment";
import FreeConsulting from "./Components/Home/Consulting/FreeConsulting";
import ConsSuccessPaid from "./Components/Home/Consulting/ConsSuccessPaid";
import ConversaionList from "./Components/Home/Chat/ConversationList";
import Chat from "./Components/Home/Chat/Chat";

function App() {
  const TRACKING_ID = 'G-WXXY51WXBX';
  ReactGA.initialize(TRACKING_ID);
  
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);

  useEffect(() => {
    Metrix.initialize({
      appId: "kgpeywvsosozeia",
    });
  }, []);

  useEffect(() => {
    requestPermission();
    const unsubscribe = onMessageListener().then((payload) => {
      console.log('Notification Recieved', payload);
      toast(
        <div className="push-notification">
          <h2 className="push-notification-title">{payload?.notification?.title}</h2>
          <p className="push-notification-text">{payload?.notification?.body}</p>
        </div>,
        {
          position: "top-center",
          hideProgressBar: true,
          closeOnClick: true,
          theme: "light"
        }
      );
    });
    return () => {
      unsubscribe.catch((err) => console.log('failed: ', err));
    };
  }, []);

  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Intro />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/getcode" element={<GetCode />} />
        <Route path="/home" element={<Home />} />
        <Route path="/job" element={<Job />} />
        <Route path="/job-list/:type" element={<JobList />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/send-resume-job/:id" element={<SendResumeJob />} />

        <Route path="/profile/send-resume-job/:id" element={<SendResumeJob />} />
        <Route path="/send-resume-education/:id" element={<SendResumeEducation />} />
        <Route path="/profile/send-resume-education/:id" element={<SendResumeEducation />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/resume/:id" element={<Resume />} />
        <Route path="/profile/resume/:id" element={<Resume />} />
        <Route path="/single-resume/:id" element={<SingleResume />} />
        <Route path="/make-resume" element={<MakeResume />} />
        <Route path="/education" element={<Education />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/articles-single/:post_id" element={<ArticleSingle />} />
        <Route path="/education-single/:id" element={<EducationSingle />} />
        <Route path="/cons-paid" element={<Consulting />} />
        <Route path="/free-consulting" element={<FreeConsulting />} />
        <Route path="/cons-type" element={<ConsTypeSelect />} />
        <Route path="/cons-payment" element={<ConsPayment />} />
        <Route path="/cons-success-payment" element={<ConsSuccessPaid />} />
        <Route path="/single-job/:id" element={<SingleJob />} />
        <Route path="/continents" element={<Continents />} />
        <Route path="/countries/:continent" element={<Countries />} />
        <Route path="/countrysingle/:id" element={<CountrySingle />} />
        <Route path="/details" element={<Details />} />
        <Route path="/pay-resume" element={<PayResume />} />
        <Route path="/pay-job" element={<PayJob />} />
        <Route path="/pay-education" element={<PayEducation />} />
        <Route path="/job-pay-success" element={<JobPaySuccess />} />
        <Route path="/education-pay-success" element={<EducationPaySuccess />} />
        <Route path="/conversations" element={<ConversaionList />} />
        <Route path="/chat/:roomId" element={<Chat />} />
      </Routes>
    </>
  );
}

export default App;